<script>
import Router from "svelte-spa-router";
import EmetersList from "./EmetersList.svelte";
import NotFound from "./NotFound.svelte";
import Info from "./Info.svelte";
import TopNav from "../components/TopNav.svelte";
import LoadingScreen from "../components/LoadingScreen.svelte";
// import replace from "svelte-spa-router";

import { wrap } from "svelte-spa-router/wrap";
import { integrated_list, loaded, user } from "../stores";
import { onMount } from "svelte";

export let params = {};

const routeEvent = e => {
	console.warn('Caught event routeEvent', e.detail)
}

const prefix = ''

const innerRoutes = {
	'/': wrap({
		component:EmetersList
	}),
	'/device_list': EmetersList,
	'/subscribed_list': Info,
	// '/info': Info,
	'/*': NotFound,
	
}

</script>

<main>
	{#if $loaded}
		<TopNav/>
		<Router routes={innerRoutes} {prefix} on:routeEvent={routeEvent} restoreScrollState={true}/>

	{:else}
		<LoadingScreen/>
	{/if}
</main>
